module.exports = __webpack_public_path__ + "img/9.aef051aa.png";